import { useCallback, use, useEffect, useState } from 'react';
import { Spinner, Table } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import useAlert from '../../Alerts/useAlert';
import ConfigurationContext from '../../Contexts/ConfigurationContext';
import { useHttpUtils } from '../../Utilities/useHttpUtils';
import AdminTile from './AdminTile';

const GetLotsWithMostImports = () => {
    const { configurationData } = use(ConfigurationContext);
    const { setAlert } = useAlert();
    const { fetchDataAuthenticated } = useHttpUtils();
    const [lots, setLots] = useState([]);
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState();
    const [variant, setVariant] = useState();
    const [importLimit, setImportLimit] = useState();
    useEffect(() => {
        if (configurationData) {
            let importLimitConfig = configurationData.find(x => x.name === "Import.LotRevisionLimit");
            setImportLimit(importLimitConfig?.value);
        }

    }, [configurationData]);

    const getImports = useCallback(async () => {
        setLoading(true);
        await fetchDataAuthenticated("api/v1/admin/lotsWithImports/10", "GET")
            .then(response => {
                if (response.status === 403) {
                    return Promise.reject({ title: "Unauthorised", detail: "Unable to fetch lots with most imports due to being unauthorised. Admin privilege required" });
                }
                if (!response.ok) {
                    return response.json().then(error => Promise.reject(error));
                }
                return response.json();
            })
            .then(data => {
                setError("");
                setLots(data);
                if (data.length === 0) {
                    setVariant("warning");
                }
                else {
                    setVariant("");
                }
            })
            .catch(error => {
                setLots();
                setVariant("danger");
                setAlert("danger", error.title, error.detail);
                setError(error.detail);
            })
            .finally(() => setLoading(false));
        ;
    }, [fetchDataAuthenticated, setAlert]);

    useEffect(() => {
        getImports();
    }, [getImports]);

    function ImportsTable() {
        if (loading) {
            return (<Spinner />);
        }
        if (error) {
            return (<div>{error}</div>);
        }

        if (lots.length === 0) {
            return (<div>No Lots</div>);
        }

        return (
            <>
                <div>Import Limit:{importLimit}</div>
                <Table>
                    <thead>
                        <tr>
                            <th>Lot Number</th>
                            <th>Import Times</th>
                            <th>Blocked?</th>
                        </tr>
                    </thead>
                    <tbody>
                        {lots && lots.map((lot, index) =>
                            <tr key={`lots-import-table${lot.lotNumber}`}>
                                <td><Link to={{ pathname: `/lotdetails/${lot.lotNumber}` }}>{lot.lotNumber}</Link></td>
                                <td>{lot.numberOfImports}</td>
                                <td>{lot.isBlocked ? "Yes" : "No"}</td>
                            </tr>
                        )}
                    </tbody>
                </Table>
            </>
        )
    }

    return (
        <AdminTile
            title={"Lots With The Most Imports"}
            description={"View the lots with the most lot imports"}
            variant={variant}
            onRefresh={getImports}>
            <ImportsTable />
        </AdminTile>
    );
}

export default GetLotsWithMostImports;